
import { Cos } from './cos'

class WorkOrder {
    #COS;
    constructor() {
        this.#COS = new Cos({
            prefix: '/WorkOrder2/*',
            path: '/WorkOrder2/Attachment2222'
        })
    }
    async putObject(file, options) {
        return await this.#COS.putObject(file, options)
    }
    getBasePrefix() {
        return this.#COS.basePrefix;
    }
    cancelTask(id) {
        return this.#COS.cancelTask(id)
    }
}

export default new WorkOrder();